import { Role } from "../../types/role";

const FVve: Role = {
  primary: [
    "Deckung",
    "Tackling",
    "Antizipation",
    "Einsatzfreude",
    "Stellungsspiel",
    "Teamwork",
    "Antritt",
    "Ausdauer",
  ],
  secondary: [
    "Dribbling",
    "Flanken",
    "Passen",
    "Technik",
    "Entscheidungen",
    "Konzentration",
    "OhneBall",
    "Beweglichkeit",
    "Schnelligkeit",
  ],
  physis: "abwehr",
};
const FVun: Role = {
  primary: [
    "Deckung",
    "Tackling",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Antritt",
    "Ausdauer",
  ],
  secondary: [
    "Dribbling",
    "Flanken",
    "Passen",
    "Technik",
    "Antizipation",
    "Entscheidungen",
    "Konzentration",
    "Stellungsspiel",
    "Beweglichkeit",
    "Schnelligkeit",
  ],
  physis: "abwehr",
};

const FVan: Role = {
  primary: [
    "Dribbling",
    "Flanken",
    "Tackling",
    "Technik",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Antritt",
    "Ausdauer",
    "Schnelligkeit",
  ],
  secondary: [
    "Deckung",
    "Passen",
    "Antizipation",
    "Entscheidungen",
    "Flair",
    "Konzentration",
    "Stellungsspiel",
    "Beweglichkeit",
  ],
  physis: "abwehr",
};

export const FV = {
  FVve,
  FVun,
  FVan,
};
